import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[textLibraryTableDirective]',
})
export class TextLibraryTableDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}